"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _FormActions = require("../../components/FormActions/FormActions.styles");
var _FormField = require("../../components/FormField/FormField.styles");
var _spaceMixin = require("../spaceMixin");
/** @class FormMixin */
/** @method */
var FormMixin = function FormMixin(props) {
  return (0, _styledToken.default)({
    formFieldMarginBottom: 'Form.FormField.marginBottom',
    formActionMarginTop: 'Form.FormAction.marginTop'
  }, function (_ref) {
    var formFieldMarginBottom = _ref.formFieldMarginBottom,
      formActionMarginTop = _ref.formActionMarginTop;
    return (0, _styledComponents.css)(["", ":not(:last-child){margin-bottom:", ";}", "{margin-top:", ";}"], _FormField.StyledFormField, formFieldMarginBottom ? formFieldMarginBottom + "px" : (0, _spaceMixin.spaceMixin)('sm')(props), _FormActions.StyledFormActions, formActionMarginTop ? formActionMarginTop + "px" : (0, _spaceMixin.spaceMixin)('lg')(props));
  })(props);
};
exports.FormMixin = FormMixin;